import React from 'react';
import { Form, Input, Select } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { JOB_TYPE_OPTIONS, SHIFT_OPTIONS } from '../../../../data/constant';
function FormEmployee({ formRef, onFinish, initialValues = {}  }) {  
  return (
    <Form name="Form" ref={formRef} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-1 '>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="UserName" label="ชื่อผู้ใช้" rules={[{ required: true, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อผู้ใช้"
          />
        </Form.Item>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="password" label="รหัสผ่าน" rules={[{ required: true, message: 'กรุณาระบุรหัสผ่าน' }]}>
          <Input.Password
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="รหัสผ่าน"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="JobType" label="Job Type" rules={[{ required: true, message: 'กรุณาระบุตำเเหน่ง' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={JOB_TYPE_OPTIONS}
          />
        </Form.Item>
        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="Shift" label="Shift" rules={[{ required: true, message: 'กรุณาระบุตำเเหน่ง' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={SHIFT_OPTIONS}
          />
        </Form.Item>
      </div>
    </Form>
  );
}

export default FormEmployee;

